import cs from 'classnames';
import Image from 'next/image';
import type { FC } from 'react';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
type IProps = Pick<ISubscriptionPlan, 'subscriptionDescription'>;
const SubscriptionDescription: FC<IProps> = ({
  subscriptionDescription
}) => {
  const items = subscriptionDescription?.split('\n') ?? [];
  return items.map(item => <li className="mb-3 flex flex-row items-center" key={item}>
      {item.includes('-') ? <Image width={16} height={16} src={`${FILE_BROWSER_URL}/img/cancel.webp`} className={cs(`text-greenThree w-[16px] min-w-[16px] ml-2`)} alt="cancel" /> : <Image width={16} height={16} src={`${FILE_BROWSER_URL}/img/accept.webp`} className={cs(`text-greenThree w-[16px] min-w-[16px] ml-2`)} alt="accept" />}
      <span className={cs(`text-sm md:text-md text-blackFive`)}>{item.replace('-', '')}</span>
    </li>);
};
export default SubscriptionDescription;